"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveActions = exports.moveReducer = void 0;
const setDeep_1 = __importDefault(require("./utils/setDeep"));
const createAction_1 = require("./createAction");
function moveReducer(move, action) {
    var _a, _b, _c, _d;
    switch (action.type) {
        case "setField": {
            const newMove = setDeep_1.default(move, action.payload.field, action.payload.value);
            if (action.payload.field.startsWith("customer.")) {
                return {
                    ...newMove,
                    loadingAddresses: move.loadingAddresses.map((loadingAddress) => loadingAddress.isCustomerAddress
                        ? { ...loadingAddress, ...newMove.customer }
                        : loadingAddress),
                };
            }
            return newMove;
        }
        case "setLoadingAddressField":
            return {
                ...move,
                loadingAddresses: move.loadingAddresses.length > 0
                    ? move.loadingAddresses.map((address) => {
                        if (address.id === action.payload.id) {
                            return {
                                ...setDeep_1.default(address, action.payload.field, action.payload.value),
                                isCustomerAddress: false,
                            };
                        }
                        else {
                            return address;
                        }
                    })
                    : [
                        setDeep_1.default({ id: "default", ...move.customer }, action.payload.field, action.payload.value),
                    ],
            };
        case "addLoadingAddress":
            return {
                ...move,
                loadingAddresses: [
                    ...(move.loadingAddresses.length > 0
                        ? move.loadingAddresses
                        : [{ id: "default", ...move.customer, isCustomerAddress: true }]),
                    action.payload,
                ],
            };
        case "removeLoadingAddress":
            return {
                ...move,
                loadingAddresses: move.loadingAddresses.filter(({ id }) => id !== action.payload),
                loadingDates: move.loadingDates.filter(({ id }) => id !== action.payload),
                drivenDistances: move.drivenDistances.filter(({ from, to }) => !((from.id === action.payload && from.type === "loadingAddress") ||
                    (to.id === action.payload && to.type === "loadingAddress"))),
            };
        case "setUnloadingAddressField":
            return {
                ...move,
                unloadingAddresses: move.unloadingAddresses.map((address) => {
                    if (address.id === action.payload.id) {
                        return setDeep_1.default(address, action.payload.field, action.payload.value);
                    }
                    else {
                        return address;
                    }
                }),
            };
        case "addUnloadingAddress":
            return {
                ...move,
                unloadingAddresses: [...move.unloadingAddresses, action.payload],
            };
        case "removeUnloadingAddress":
            return {
                ...move,
                unloadingAddresses: move.unloadingAddresses.filter(({ id }) => id !== action.payload),
                unloadingDates: move.unloadingDates.filter(({ id }) => id !== action.payload),
                drivenDistances: move.drivenDistances.filter(({ from, to }) => !((from.id === action.payload &&
                    from.type === "unloadingAddress") ||
                    (to.id === action.payload && to.type === "unloadingAddress"))),
            };
        case "setDrivenDistance": {
            const existingDistance = move.drivenDistances.find((distance) => distance.from.type === action.payload.from.type &&
                distance.from.id === action.payload.from.id &&
                distance.to.type === action.payload.to.type &&
                distance.to.id === action.payload.to.id);
            if (existingDistance) {
                return {
                    ...move,
                    drivenDistances: move.drivenDistances.map((distance) => {
                        var _a, _b;
                        return distance === existingDistance
                            ? {
                                ...distance,
                                distance: (_a = action.payload.distance) !== null && _a !== void 0 ? _a : distance.distance,
                                tollDistance: (_b = action.payload.tollDistance) !== null && _b !== void 0 ? _b : distance.tollDistance,
                            }
                            : distance;
                    }),
                };
            }
            return {
                ...move,
                drivenDistances: [
                    ...move.drivenDistances,
                    {
                        from: action.payload.from,
                        to: action.payload.to,
                        distance: (_a = action.payload.distance) !== null && _a !== void 0 ? _a : 0,
                        tollDistance: (_b = action.payload.tollDistance) !== null && _b !== void 0 ? _b : 0,
                    },
                ],
            };
        }
        case "addRoom":
            return { ...move, rooms: [...move.rooms, action.payload] };
        case "removeRoom":
            return {
                ...move,
                rooms: move.rooms.filter(({ id }) => id !== action.payload),
            };
        case "addRoomItem":
            return {
                ...move,
                rooms: move.rooms.map((room) => room.id === action.payload.roomId
                    ? {
                        ...room,
                        items: [...room.items, action.payload.item],
                    }
                    : room),
            };
        case "setRoomItemAmount":
            return {
                ...move,
                rooms: move.rooms.map((room) => room.id === action.payload.roomId
                    ? {
                        ...room,
                        items: room.items.map((item) => item.id === action.payload.itemId
                            ? { ...item, amount: action.payload.amount }
                            : item),
                    }
                    : room),
            };
        case "editRoomItem":
            return {
                ...move,
                rooms: move.rooms.map((room) => room.id === action.payload.roomId
                    ? {
                        ...room,
                        items: room.items.map((item) => item.id === action.payload.itemId
                            ? { ...item, ...action.payload.updates }
                            : item),
                    }
                    : room),
            };
        case "removeRoomItem":
            return {
                ...move,
                rooms: move.rooms.map((room) => room.id === action.payload.roomId
                    ? {
                        ...room,
                        items: room.items.filter((item) => item.id !== action.payload.itemId),
                    }
                    : room),
            };
        case "setRoomField":
            return {
                ...move,
                rooms: move.rooms.map((room) => room.id === action.payload.roomId
                    ? {
                        ...room,
                        [action.payload.field]: action.payload.value,
                    }
                    : room),
            };
        case "setLoadingDate":
            return {
                ...move,
                loadingDates: replaceOrAddArrayItemById((_c = move.loadingDates) !== null && _c !== void 0 ? _c : [], action.payload.id, (date) => date.id, (date) => ({
                    ...date,
                    id: action.payload.id,
                    date: "date" in action.payload ? action.payload.date : date === null || date === void 0 ? void 0 : date.date,
                    alternateDate: "alternateDate" in action.payload
                        ? action.payload.alternateDate
                        : date === null || date === void 0 ? void 0 : date.alternateDate,
                    packingMaterialDate: "packingMaterialDate" in action.payload
                        ? action.payload.packingMaterialDate
                        : date === null || date === void 0 ? void 0 : date.packingMaterialDate,
                })),
            };
        case "setUnloadingDate":
            return {
                ...move,
                unloadingDates: replaceOrAddArrayItemById((_d = move.unloadingDates) !== null && _d !== void 0 ? _d : [], action.payload.id, (date) => date.id, (date) => ({
                    ...date,
                    id: action.payload.id,
                    date: "date" in action.payload ? action.payload.date : date === null || date === void 0 ? void 0 : date.date,
                    alternateDate: "alternateDate" in action.payload
                        ? action.payload.alternateDate
                        : date === null || date === void 0 ? void 0 : date.alternateDate,
                })),
            };
        default:
            return otherReducers(move, action);
    }
}
exports.moveReducer = moveReducer;
const { action: setPackingMaterialAmountOverride, reducer: setPackingMaterialAmountOverrideReducer, } = createAction_1.createAction("setPackingMaterialAmountOverride", (move, action) => {
    var _a;
    return {
        ...move,
        packingMaterialOverrides: replaceOrAddArrayItemById((_a = move.packingMaterialOverrides) !== null && _a !== void 0 ? _a : [], action.payload.packingMaterialId, (material) => material.id, (material) => {
            var _a, _b;
            const amount = "amount" in action.payload
                ? action.payload.amount
                : (_a = material === null || material === void 0 ? void 0 : material.amount) !== null && _a !== void 0 ? _a : null;
            let inAdvance = "inAdvance" in action.payload
                ? action.payload.inAdvance
                : (_b = material === null || material === void 0 ? void 0 : material.inAdvance) !== null && _b !== void 0 ? _b : null;
            return {
                id: action.payload.packingMaterialId,
                amount,
                inAdvance: inAdvance != null && amount != null
                    ? Math.min(amount, inAdvance)
                    : inAdvance,
            };
        }),
    };
});
const { action: addLoadingAddressPhoto, reducer: addLoadingAddressPhotoReducer, } = createAction_1.createAction("addLoadingAddressPhoto", (move, action) => {
    return {
        ...move,
        loadingAddresses: move.loadingAddresses.length > 0
            ? move.loadingAddresses.map((address) => {
                var _a;
                return address.id === action.payload.id
                    ? {
                        ...address,
                        photos: [
                            ...((_a = address.photos) !== null && _a !== void 0 ? _a : []),
                            { id: action.payload.attachmentId },
                        ],
                    }
                    : address;
            })
            : [
                setDeep_1.default({ id: "default", ...move.customer, isCustomerAddress: true }, "photos", [{ id: action.payload.attachmentId }]),
            ],
    };
});
const { action: removeLoadingAddressPhoto, reducer: removeLoadingAddressPhotoReducer, } = createAction_1.createAction("removeLoadingAddressPhoto", (move, action) => {
    return {
        ...move,
        loadingAddresses: move.loadingAddresses.map((address) => {
            var _a;
            return address.id === action.payload.id
                ? {
                    ...address,
                    photos: (_a = address.photos) === null || _a === void 0 ? void 0 : _a.filter((photo) => photo.id !== action.payload.attachmentId),
                }
                : address;
        }),
    };
});
const { action: addUnloadingAddressPhoto, reducer: addUnloadingAddressPhotoReducer, } = createAction_1.createAction("addUnloadingAddressPhoto", (move, action) => {
    return {
        ...move,
        unloadingAddresses: move.unloadingAddresses.map((address) => {
            var _a;
            return address.id === action.payload.id
                ? {
                    ...address,
                    photos: [
                        ...((_a = address.photos) !== null && _a !== void 0 ? _a : []),
                        { id: action.payload.attachmentId },
                    ],
                }
                : address;
        }),
    };
});
const { action: removeUnloadingAddressPhoto, reducer: removeUnloadingAddressPhotoReducer, } = createAction_1.createAction("removeUnloadingAddressPhoto", (move, action) => {
    return {
        ...move,
        unloadingAddresses: move.unloadingAddresses.map((address) => {
            var _a;
            return address.id === action.payload.id
                ? {
                    ...address,
                    photos: (_a = address.photos) === null || _a === void 0 ? void 0 : _a.filter((photo) => photo.id !== action.payload.attachmentId),
                }
                : address;
        }),
    };
});
const { action: setContractorCount, reducer: setContractorCountReducer, } = createAction_1.createAction("setContractorCount", (move, action) => {
    var _a;
    return {
        ...move,
        contractors: replaceOrAddArrayItemById((_a = move.contractors) !== null && _a !== void 0 ? _a : [], action.payload.contractorId, (contractor) => contractor.id, (contractor) => {
            var _a;
            return {
                id: action.payload.contractorId,
                ...contractor,
                count: (_a = action.payload.count) !== null && _a !== void 0 ? _a : 0,
            };
        }),
    };
});
const { action: setContractorCost, reducer: setContractorCostReducer, } = createAction_1.createAction("setContractorCost", (move, action) => {
    var _a;
    return {
        ...move,
        contractors: replaceOrAddArrayItemById((_a = move.contractors) !== null && _a !== void 0 ? _a : [], action.payload.contractorId, (contractor) => contractor.id, (contractor) => {
            var _a;
            return {
                id: action.payload.contractorId,
                ...contractor,
                cost: (_a = action.payload.cost) !== null && _a !== void 0 ? _a : 0,
            };
        }),
    };
});
const { action: addCustomContractor, reducer: addCustomContractorReducer, } = createAction_1.createAction("addCustomContractor", (move, action) => {
    var _a;
    return {
        ...move,
        customContractors: [...((_a = move.customContractors) !== null && _a !== void 0 ? _a : []), action.payload],
    };
});
const { action: updateCustomContractor, reducer: updateCustomContractorReducer, } = createAction_1.createAction("updateCustomContractor", (move, action) => {
    var _a;
    return {
        ...move,
        customContractors: replaceOrAddArrayItemById((_a = move.customContractors) !== null && _a !== void 0 ? _a : [], action.payload.id, (contractor) => contractor.id, (contractor) => spreadNonUndefined(contractor !== null && contractor !== void 0 ? contractor : { id: action.payload.id, name: "" }, action.payload)),
    };
});
const { action: removeCustomContractor, reducer: removeCustomContractorReducer, } = createAction_1.createAction("removeCustomContractor", (move, action) => {
    var _a;
    return {
        ...move,
        customContractors: (_a = move.customContractors) === null || _a === void 0 ? void 0 : _a.filter((c) => c.id !== action.payload.id),
    };
});
const { action: addInvoicePosition, reducer: addInvoicePositionReducer, } = createAction_1.createAction("addInvoicePosition", (move, action) => {
    var _a, _b, _c, _d;
    return {
        ...move,
        documentData: {
            ...move.documentData,
            invoice: {
                ...(_a = move.documentData) === null || _a === void 0 ? void 0 : _a.invoice,
                additionalServices: [
                    ...((_d = (_c = (_b = move.documentData) === null || _b === void 0 ? void 0 : _b.invoice) === null || _c === void 0 ? void 0 : _c.additionalServices) !== null && _d !== void 0 ? _d : []),
                    {
                        id: action.payload.id,
                    },
                ],
            },
        },
    };
});
const { action: updateInvoicePosition, reducer: updateInvoicePositionReducer, } = createAction_1.createAction("updateInvoicePosition", (move, action) => {
    var _a, _b, _c, _d;
    return {
        ...move,
        documentData: {
            ...move.documentData,
            invoice: {
                ...(_a = move.documentData) === null || _a === void 0 ? void 0 : _a.invoice,
                additionalServices: replaceOrAddArrayItemById((_d = (_c = (_b = move.documentData) === null || _b === void 0 ? void 0 : _b.invoice) === null || _c === void 0 ? void 0 : _c.additionalServices) !== null && _d !== void 0 ? _d : [], action.payload.id, (item) => item.id, (item) => ({
                    ...item,
                    ...action.payload,
                })),
            },
        },
    };
});
const { action: removeInvoicePosition, reducer: removeInvoicePositionReducer, } = createAction_1.createAction("removeInvoicePosition", (move, action) => {
    var _a, _b, _c, _d;
    return {
        ...move,
        documentData: {
            ...move.documentData,
            invoice: {
                ...(_a = move.documentData) === null || _a === void 0 ? void 0 : _a.invoice,
                additionalServices: (_d = (_c = (_b = move.documentData) === null || _b === void 0 ? void 0 : _b.invoice) === null || _c === void 0 ? void 0 : _c.additionalServices) === null || _d === void 0 ? void 0 : _d.filter((service) => service.id !== action.payload.id),
            },
        },
    };
});
const { action: setRecalculationPackingMaterialAmount, reducer: setRecalculationPackingMaterialAmountReducer, } = createAction_1.createAction("setRecalculationPackingMaterialAmount", (move, action) => {
    var _a, _b;
    return ({
        ...move,
        recalculation: {
            ...move.recalculation,
            packingMaterial: replaceOrAddArrayItemById((_b = (_a = move === null || move === void 0 ? void 0 : move.recalculation) === null || _a === void 0 ? void 0 : _a.packingMaterial) !== null && _b !== void 0 ? _b : [], action.payload.packingMaterialId, (item) => item.id, (item) => ({
                id: action.payload.packingMaterialId,
                ...item,
                amount: action.payload.amount,
            })),
        },
    });
});
const { action: setRecalculationNoParkingZoneFees, reducer: setRecalculationNoParkingZoneFeesReducer, } = createAction_1.createAction("setRecalculationNoParkingZoneFees", (move, action) => {
    var _a, _b, _c, _d;
    if ("loadingAddressId" in action.payload) {
        const loadingAddressId = action.payload.loadingAddressId;
        return {
            ...move,
            recalculation: {
                ...move.recalculation,
                noParkingZones: replaceOrAddArrayItemById((_b = (_a = move === null || move === void 0 ? void 0 : move.recalculation) === null || _a === void 0 ? void 0 : _a.noParkingZones) !== null && _b !== void 0 ? _b : [], loadingAddressId, (item) => ("loadingAddressId" in item ? item.loadingAddressId : ""), (item) => ({
                    loadingAddressId,
                    ...item,
                    ...action.payload,
                })),
            },
        };
    }
    else if ("unloadingAddressId" in action.payload) {
        const unloadingAddressId = action.payload.unloadingAddressId;
        return {
            ...move,
            recalculation: {
                ...move.recalculation,
                noParkingZones: replaceOrAddArrayItemById((_d = (_c = move === null || move === void 0 ? void 0 : move.recalculation) === null || _c === void 0 ? void 0 : _c.noParkingZones) !== null && _d !== void 0 ? _d : [], unloadingAddressId, (item) => "unloadingAddressId" in item ? item.unloadingAddressId : "", (item) => ({
                    unloadingAddressId,
                    ...item,
                    ...action.payload,
                })),
            },
        };
    }
    else {
        return move;
    }
});
const { action: updateRecalculationContractor, reducer: updateRecalculationContractorReducer, } = createAction_1.createAction("updateRecalculationContractor", (move, action) => {
    var _a, _b;
    const { contractorId, ...payload } = action.payload;
    return {
        ...move,
        recalculation: {
            ...move.recalculation,
            contractors: replaceOrAddArrayItemById((_b = (_a = move.recalculation) === null || _a === void 0 ? void 0 : _a.contractors) !== null && _b !== void 0 ? _b : [], contractorId, (contractor) => contractor.id, (contractor) => ({
                id: contractorId,
                ...contractor,
                ...payload,
            })),
        },
    };
});
const { action: addRecalculationCustomContractor, reducer: addRecalculationCustomContractorReducer, } = createAction_1.createAction("addRecalculationCustomContractor", (move, action) => {
    var _a, _b;
    return {
        ...move,
        recalculation: {
            ...move.recalculation,
            customContractors: [
                ...((_b = (_a = move.recalculation) === null || _a === void 0 ? void 0 : _a.customContractors) !== null && _b !== void 0 ? _b : []),
                action.payload,
            ],
        },
    };
});
const { action: updateRecalculationCustomContractor, reducer: updateRecalculationCustomContractorReducer, } = createAction_1.createAction("updateRecalculationCustomContractor", (move, action) => {
    var _a, _b;
    return {
        ...move,
        recalculation: {
            ...move.recalculation,
            customContractors: replaceOrAddArrayItemById((_b = (_a = move.recalculation) === null || _a === void 0 ? void 0 : _a.customContractors) !== null && _b !== void 0 ? _b : [], action.payload.id, (contractor) => contractor.id, (contractor) => spreadNonUndefined(contractor !== null && contractor !== void 0 ? contractor : { id: action.payload.id, name: "" }, action.payload)),
        },
    };
});
const { action: removeRecalculationCustomContractor, reducer: removeRecalculationCustomContractorReducer, } = createAction_1.createAction("removeRecalculationCustomContractor", (move, action) => {
    var _a, _b;
    return {
        ...move,
        recalculation: {
            ...move.recalculation,
            customContractors: (_b = (_a = move.recalculation) === null || _a === void 0 ? void 0 : _a.customContractors) === null || _b === void 0 ? void 0 : _b.filter((c) => c.id !== action.payload.id),
        },
    };
});
const { action: addRecalculationOtherPosition, reducer: addRecalculationOtherPositionReducer, } = createAction_1.createAction("addRecalculationOtherPosition", (move, action) => {
    var _a, _b;
    return {
        ...move,
        recalculation: {
            ...move.recalculation,
            other: [...((_b = (_a = move.recalculation) === null || _a === void 0 ? void 0 : _a.other) !== null && _b !== void 0 ? _b : []), action.payload],
        },
    };
});
const { action: updateRecalculationOtherPosition, reducer: updateRecalculationOtherPositionReducer, } = createAction_1.createAction("updateRecalculationOtherPosition", (move, action) => {
    var _a, _b;
    return {
        ...move,
        recalculation: {
            ...move.recalculation,
            other: replaceOrAddArrayItemById((_b = (_a = move.recalculation) === null || _a === void 0 ? void 0 : _a.other) !== null && _b !== void 0 ? _b : [], action.payload.id, (item) => item.id, (item) => ({
                ...item,
                ...action.payload,
            })),
        },
    };
});
const { action: removeRecalculationOtherPosition, reducer: removeRecalculationOtherPositionReducer, } = createAction_1.createAction("removeRecalculationOtherPosition", (move, action) => {
    var _a, _b;
    return {
        ...move,
        recalculation: {
            ...move.recalculation,
            other: (_b = (_a = move.recalculation) === null || _a === void 0 ? void 0 : _a.other) === null || _b === void 0 ? void 0 : _b.filter((item) => item.id !== action.payload.id),
        },
    };
});
exports.moveActions = {
    setPackingMaterialAmountOverride,
    addLoadingAddressPhoto,
    addUnloadingAddressPhoto,
    setContractorCount,
    setContractorCost,
    addCustomContractor,
    updateCustomContractor,
    removeCustomContractor,
    addInvoicePosition,
    updateInvoicePosition,
    removeInvoicePosition,
    setRecalculationPackingMaterialAmount,
    setRecalculationNoParkingZoneFees,
    updateRecalculationContractor,
    addRecalculationCustomContractor,
    updateRecalculationCustomContractor,
    removeRecalculationCustomContractor,
    addRecalculationOtherPosition,
    updateRecalculationOtherPosition,
    removeRecalculationOtherPosition,
};
const reducers = {
    setPackingMaterialAmountOverride: setPackingMaterialAmountOverrideReducer,
    addLoadingAddressPhoto: addLoadingAddressPhotoReducer,
    removeLoadingAddressPhoto: removeLoadingAddressPhotoReducer,
    addUnloadingAddressPhoto: addUnloadingAddressPhotoReducer,
    removeUnloadingAddressPhoto: removeUnloadingAddressPhotoReducer,
    setContractorCost: setContractorCostReducer,
    setContractorCount: setContractorCountReducer,
    addCustomContractor: addCustomContractorReducer,
    updateCustomContractor: updateCustomContractorReducer,
    removeCustomContractor: removeCustomContractorReducer,
    addInvoicePosition: addInvoicePositionReducer,
    updateInvoicePosition: updateInvoicePositionReducer,
    removeInvoicePosition: removeInvoicePositionReducer,
    setRecalculationPackingMaterialAmount: setRecalculationPackingMaterialAmountReducer,
    updateRecalculationContractor: updateRecalculationContractorReducer,
    setRecalculationNoParkingZoneFees: setRecalculationNoParkingZoneFeesReducer,
    addRecalculationCustomContractor: addRecalculationCustomContractorReducer,
    updateRecalculationCustomContractor: updateRecalculationCustomContractorReducer,
    removeRecalculationCustomContractor: removeRecalculationCustomContractorReducer,
    addRecalculationOtherPosition: addRecalculationOtherPositionReducer,
    updateRecalculationOtherPosition: updateRecalculationOtherPositionReducer,
    removeRecalculationOtherPosition: removeRecalculationOtherPositionReducer,
};
function otherReducers(move, action) {
    const reducer = reducers[action.type];
    if (reducer) {
        return reducer(move, action);
    }
    return move;
}
function replaceOrAddArrayItemById(array, id, getId, upsert) {
    let found = false;
    const mapped = array.map((item) => {
        if (!found) {
            const currentId = getId(item);
            if (currentId === id) {
                found = true;
                return upsert(item);
            }
        }
        return item;
    });
    if (!found) {
        mapped.push(upsert());
    }
    return mapped;
}
function spreadNonUndefined(a, b) {
    for (const [key, value] of Object.entries(b)) {
        if (value !== undefined) {
            a[key] = value;
        }
    }
    return a;
}
//# sourceMappingURL=moveReducer.js.map